module.exports = __webpack_public_path__ + "static/media/elixir-exhibitions.1bd2e600.pdf";